<div style="width: 550px;height: 450px; font-size: 24px; padding: 15px;">
    <header>
        <div class="flex justify-between items-center p-2">
            <span class="text-[20px] font-bold">{{template.form_name}}</span>
            <button type="button" class="close add-close-button" style="position: relative; top: -6px"  (click)="closeDialog()">
                <span style="font-size: 24px; font-weight: 600; color: #707070" class="material-icons icons-close-mobile">close</span>
            </button>
        </div>
    </header>
    <div class="flex flex-col gap-2 justify-center items-center">
        <div class="flex flex-col gap-2">
            <img src="assets/images/non-access-template.svg" alt="non-access-template" style="    height: 246px;
            width: 259px;
            margin-top: 50px;" />
            <span class="text-lg font-semibold">This file is not accessible</span>
        </div>
    </div>
</div>
